import React from 'react';
import {
  CopyBlock,
  CopyBlockAlignment,
  CopyBlockProps,
} from '@noths/polaris-client-ribbons-design-system';
import parse from 'html-react-parser';

import { trackLinkClick } from 'src/tracking/components/copyBlock';
import { TrackingContext } from 'src/types/TrackingContext';
import { trackImpression } from '../../../tracking/common/trackImpression';
import { BlockContainer } from '../BlockContainer/BlockContainer';
import * as styles from './CopyBlockBlock.style';

export interface CopyBlockBlockProps extends CopyBlockProps {
  children: string;
  trackingTitle: string;
  trackingPosition?: number;
}

export const CopyBlockBlock = ({
  alignment,
  children,
  trackingPosition,
  trackingTitle,
}: CopyBlockBlockProps) => {
  const trackingContext: TrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'Copy block',
  };

  return (
    <BlockContainer wrapperStyles={styles.wrapper} maxWidth="full" columnsL={8}>
      <CopyBlock
        alignment={alignment}
        onLinkClick={(e: React.MouseEvent) => trackLinkClick(e, trackingContext)}
        onVisible={() => trackImpression(trackingContext)}
      >
        {parse(children)}
      </CopyBlock>
    </BlockContainer>
  );
};

export type { CopyBlockProps, CopyBlockAlignment };
